import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-dev-deploy-docs',
  templateUrl: './dev-deploy-docs.component.html',
  styleUrls: ['./dev-deploy-docs.component.css'],
  standalone: false
})
export class DevDeployDocsComponent {
  readonly production = environment.production;

  readonly deployFrontCmd =
`./deploy/deploy.sh front root@31.220.81.29 \\
  --frontend-src /home/tpn/Dokumente/eLocation/softpay \\
  --frontend-build-cmd "npm ci && npm run build -- --configuration production"`;

  readonly deployBackCmd =
`./deploy/deploy.sh back root@31.220.81.29 --env-file deploy/docker/.env`;

  readonly deployAllCmd =
`./deploy/deploy.sh all root@31.220.81.29 \\
  --frontend-src /home/tpn/Dokumente/eLocation/softpay \\
  --env-file deploy/docker/.env`;

  readonly dbeaverTunnelCmd =
`PG_IP=$(ssh root@31.220.81.29 "docker inspect -f '{{range .NetworkSettings.Networks}}{{.IPAddress}}{{end}}' softpay-postgres")
ssh -N -L 55432:${'$'}{PG_IP}:5432 root@31.220.81.29`;
}
